import "./Logo.css";

type LogoProps = {
  className?: string;
};

export const Logo = ({ className = "" }: LogoProps) => {
  return (
    <div className={`logo-root ${className}`.trim()}>
      <span className="logo-name">
        Sandras <span className="logo-accent">hälsa</span>
      </span>
      <div className="logo-rule" />
    </div>
  );
};

export default Logo;
